import React from 'react';
import moment from 'moment';
import { getAnalyticsReportDates } from '../../../services/mini/analytics/getAnalyticsReportDates';
import { getDatePickerLabelByDates } from '../../../services/mini/analytics/getDatePickerLabelByDates';
import { AnalyticsChartPeriods } from '../../../services/mini/analytics/analyticsChartPeriods';

export const DatePickerLabel = React.forwardRef(({ period, value, onClick }, ref) => {
    const [startDateStr, endDateStr] = value.split(' - ');
    let { startTs, endTs } = getAnalyticsReportDates(moment(startDateStr), endDateStr ? moment(endDateStr) : null, period);

    const output = getDatePickerLabelByDates(startTs, endTs);

    let calendarIcon;

    if (period === AnalyticsChartPeriods.Daily) {
        calendarIcon = 'icon-alan-stat-calendar';
    } else if (period === AnalyticsChartPeriods.Weekly) {
        calendarIcon = 'icon-alan-stat-calendar-week';
    } else {
        calendarIcon = 'icon-alan-stat-calendar-month';
    }

    return <div className="date-picker__label"
        onClick={onClick}
        ref={ref}>
        <i className={`icon ${calendarIcon} date-picker__icon`} />
        {output}
    </div>;
});